// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vzHa1","textarea":"styles_textarea__2VmXu"};